var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgC(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M14.312 0H2.688A2.69 2.69 0 000 2.688v11.624A2.69 2.69 0 002.688 17h11.624A2.69 2.69 0 0017 14.312V2.688A2.695 2.695 0 0014.312 0z",
    id: "a"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#B1C2C9",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1 20l3-6 15-4c1.666 4.704 1.666 7.704 0 9-1.666 1.296-7.666 1.63-18 1z",
    fill: "#D6DCDF",
    mask: "url(#b)"
  }), /*#__PURE__*/React.createElement("text", {
    mask: "url(#b)",
    fontFamily: "MuseoSlab-700, Museo Slab",
    fontSize: 11,
    fontWeight: 500,
    fill: "#FFF"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 4.402,
    y: 12
  }, "C")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgC);
export default __webpack_public_path__ + "static/media/c.8401acf70b5a6e613a634a855fc6ea5d.svg";
export { ForwardRef as ReactComponent };